import { BrowserRouter } from 'react-router-dom';
import { AuthGate } from './providers.jsx';
import { AppRoutes } from './routes.jsx';

/**
 * Raíz de la plataforma Analytics.
 * BrowserRouter envuelve AuthGate para no perder /lab/* al montar la sesión.
 */
export default function App() {
  return (
    <BrowserRouter>
      <AuthGate>
        {({ email }) => <AppRoutes email={email} />}
      </AuthGate>
    </BrowserRouter>
  );
}
